<ng-container *ngIf="productComputed() as product">
  <div class="product-card" [ngClass]="{ 'product-card--hoverable': hoverable() }">
    <div class="product-card__image">
      <div class="product-card__image--top">
        @if (product.cutoffTime) {
          <cx-cut-off-time [time]="product.cutoffTime" />
        }
      </div>

      <a [routerLink]="['/produto/', product.code, product.name]">
        <cx-media [media]="imageProduct()" (mediaError)="onImageError($event)" />
      </a>
    </div>

    <a [routerLink]="['/produto/', product.code, product.name]">
      <h3 class="product-card__name" [title]="product.name">
        {{ product.name }}
      </h3>
    </a>

    <div class="product-card__price">
      @if (isPriceLoading()) {
        <skeleton-loading class="status-loading" />
      } @else if (priceData()) {
        <div class="price-container">
          <span class="price-final">{{ priceData()?.formatedFinalPrice }}</span>
        </div>
      } @else {
        <p class="product-card__price--label">
          {{ 'product.unavaliblePrice' | translate }}
        </p>
      }
    </div>

    <cx-input-quantity [formControl]="qtyControl" />

    <cx-button
      class="w-100"
      (click)="addToCart()"
      type="button"
      variant="success"
      [loading]="isAddCartLoading"
      [disabled]="qtyControl.value! <= 0"
    >
      {{ 'product.addToCart' | translate }}
    </cx-button>

    <div class="product-card__bottom">
      @if (isStockLoading()) {
        <skeleton-loading class="status-loading" />
      } @else {
        <product-stock [has]="!!product?.stock?.data?.available" [labelable]="true" />
      }
    </div>
  </div>
</ng-container>
